
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const SitesCallToAction: React.FC = () => {
  return (
    <section className="text-center bg-gradient-to-r from-fabre-green/10 via-fabre-teal/10 to-fabre-green/10 rounded-3xl shadow-xl p-12 border border-fabre-green/20">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6 text-fabre-gray">
          Besoin d'un devis ou d'informations ?
        </h2>
        <p className="text-xl text-fabre-darkteal mb-8 leading-relaxed">
          Notre équipe d'experts est à votre disposition pour vous accompagner dans tous vos projets 
          de gestion des déchets. Contactez-nous pour obtenir un devis personnalisé et gratuit.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen text-white px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300">
            <Link to="/contact">Demander un devis gratuit</Link>
          </Button>
          <Button asChild variant="outline" className="border-fabre-teal text-fabre-teal hover:bg-fabre-teal hover:text-white px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300">
            <Link to="/nos-services">Découvrir nos services</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default SitesCallToAction;
